import React from "react";
import { Box, Typography } from "@mui/joy";

interface SubTitleProps {
  children: React.ReactNode;
  sx?: any;
}

const SubTitle: React.FC<SubTitleProps> = ({ children, sx = {} }) => {
  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Typography level="body-md" color="neutral">
        {children}
      </Typography>
    </Box>
  );
};

export default SubTitle;
